import React, { forwardRef } from 'react';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  fullWidth?: boolean;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  icon,
  fullWidth = true,
  className = '',
  ...props
}, ref) => {
  const id = props.id || props.name || Math.random().toString(36).substring(7);
  return <div className={`${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-17845">
        {label && <label htmlFor={id} className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-17846">
            {label}
          </label>}
        <div className="relative" data-id="element-17847">
          {icon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400" data-id="element-17848">
              {icon}
            </div>}
          <input ref={ref} id={id} className={`
              block w-full rounded-xl border-slate-200 shadow-sm
              focus:ring-primary focus:border-primary sm:text-sm transition-colors
              px-4 py-2.5 border outline-none
              ${icon ? 'pl-10' : ''}
              ${error ? 'border-rose-300 text-rose-900 placeholder-rose-300 focus:ring-rose-500 focus:border-rose-500' : 'text-slate-900 placeholder-slate-400'}
              disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200
            `} {...props} data-id="element-17849" />
        </div>
        {error && <p className="mt-1.5 text-sm text-rose-500" data-id="element-17850">{error}</p>}
      </div>;
});
Input.displayName = 'Input';